import styled from "styled-components"
import media from "styled-media-query"

const logos = {
  itau: require("~/assets/images/logo-itau.png"),
  portofaz: require("~/assets/images/logo-portofaz.svg"),
}

export const Container = styled.header`
  display: flex;
  align-items: center;

  height: 8.6rem;
  background-color: #fff;

  overflow: hidden;
  /* background-color: rgba(255, 0, 0, 0.1); */
`

export const Item = styled.figure`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 2rem;
  box-shadow: -5px 0px 10px rgba(0, 0, 0, 0.05);
  /* background-color: rgba(0, 255, 0, 0.2); */
`

export const Logo = styled.img.attrs(props => ({
  src: logos[props.type],
}))`
  height: 50px;

  ${media.greaterThan("medium")`
    height: 55px;
  `}
`
